<script setup lang="ts">
const device = useDevice();
const props = defineProps<{
    title: string,
    desc: string,
    img: string,
    items: Array<{
        title: string,
        desc: string
    }>
}>();
</script>

<template>
    <SectionsBase id="intro" class="container lg:scroll-m-30 2xl:scroll-m-25">
      <div class="lg:flex lg:gap-24 lg:items-center">
        <DevicesDesktop>
          <div class="w-131.25 bg-gray-50 bg-[url('/img/new/backgrounds/dot-01.webp')] border border-gray-200 rounded-[20px] p-4">
            <NuxtImg
                width="600"
                :src="props.img"
                :alt="props.title"
                class="w-full"
                loading="lazy"
            />
          </div>          
        </DevicesDesktop>
        <div 
          class="w-full relative"
          :data-aos="device.isDesktop.value && 'fade-left'"
          data-aos-duration="1000"
        >
          <DevicesMobile>
            <ChipsDivider>معرفی محصول</ChipsDivider>
          </DevicesMobile>

          <DevicesDesktop>
            <IconsCurvedArrow class="absolute -top-20 -right-30 text-secondary-600" />
            <ChipsBase type="Secondary" variant="warning" class="my-8">معرفی محصول</ChipsBase>
          </DevicesDesktop>

          <h2 class="lg:text-start">{{ props.title }}</h2>
          <p class="text-body2-semibold text-gray-400 text-center lg:text-start my-5 lg:text-[1rem]!">{{ props.desc }}</p>

          <div class="w-full flex flex-col items-center lg:flex-row gap-10 lg:gap-25">
            <DevicesMobile>
              <div
                class="bg-gray-50 bg-[url('/img/new/backgrounds/dot-01.webp')]
                  border border-gray-200 rounded-[20px] p-4"
              >
                <NuxtImg
                    width="600"
                    :src="props.img"
                    :alt="props.title"
                    class="w-full"
                    loading="lazy"
                />
              </div>
            </DevicesMobile>

              <div class="w-full flex flex-col gap-5 lg:gap-8 overflow-hidden lg:mt-5">
                <div 
                  v-for="item in props.items" 
                  :key="item.title"
                  class="w-full lg:pl-10"
                >
                  <div class="flex items-start gap-3 lg:gap-4 mb-3">
                    <Icon name="solar:check-circle-bold" size="24" class="text-secondary-600" />
                    <h3>{{ item.title }}</h3>
                  </div>
                  <p class="text-body2 text-gray-400 lg:text-[1rem]!">{{ item.desc }}</p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </SectionsBase>
</template>